import clsx from "clsx";
import ArrowRight from "../../../img/icons/arrow-right.svg?react";
import Link from "../Link";
import { moreLinkStyles, rtlArrowIconStyles } from "../links.css";
import { LinkVariant } from "../types";
import { MoreLinkProps } from "./types";

const ICON_DIMENSIONS_MAP: Record<LinkVariant, number> = {
  default: 20,
  light: 16,
};

const MoreLink = ({
  children,
  className,
  variant = "default",
  ...props
}: MoreLinkProps) => {
  const iconSize = ICON_DIMENSIONS_MAP[variant];

  return (
    <Link {...props} className={clsx(moreLinkStyles[variant], className)}>
      {children}
      <ArrowRight
        width={iconSize}
        height={iconSize}
        aria-hidden
        className={rtlArrowIconStyles}
      />
    </Link>
  );
};

export default MoreLink;
